import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import * as Server from 'assets/js/Server';

/* MODAL 관련 (기존 훅 사용) */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

const TobOrderDetailModal = props => {
  const { closeModal } = useModal();
  const [orderDetailList, setOrderDetailList] = useState([]);

  const getOrderDetailList = () => {
    Server.sendGet('shopify/order/detail', {
      shopifyOrderMstSeq: props?.props?.data?.item.shopifyOrderMstSeq
    }, getOrderDetailListCallback).then();
  }

  const getOrderDetailListCallback = res => {
    setOrderDetailList(res?.['resultList']);
  }

  useEffect(() => {
    getOrderDetailList();
  }, [props?.props?.data]);


  return (
    <>
      {/* 닫기 버튼 */}
      <CloseBtn onClick={closeModal} />

      <ModalWrapper className='modal-box'>
        <div className='inner'>
          {/* 팝업 헤더 */}
          <Title>
            <TitHead>
              <i />
              <h4>Item List</h4>
            </TitHead>
          </Title>

          {/* 메인 컨텐츠: 테이블 */}
          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Item Price</th>
                </tr>
              </thead>
              <tbody>
                {/* 데이터 매핑 영역 */}

                  {orderDetailList?.map((item, idx) => (
                    <>
                      <tr>
                        <td>{item.itemName}</td>
                        <td>{item.itemPrice} INR</td>
                      </tr>
                    </>
                  ))}
              </tbody>
            </StyledTable>
          </TableContainer>

          {/* 하단 버튼 영역 */}
          <FormBtn>
            <BtnCancel onClick={closeModal}>Close</BtnCancel>
          </FormBtn>
        </div>
      </ModalWrapper>
    </>
  );
};

/* --- Styled Components --- */

const ModalWrapper = styled.div`
  padding: 20px;
`;

const Title = styled.div`
  margin-bottom: 20px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  & i { 
    display: block; 
    width: 4px; 
    height: 24px; 
    background: #0072b9; 
    border-radius: 2px;
  }
  & h4 { 
    font-weight: 700; 
    font-size: 20px; 
    margin: 0;
  }
`;

const TableContainer = styled.div`
  margin-top: 10px;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #eeeeee;
  border-radius: 8px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  thead {
    background-color: #f8f9fa;
    position: sticky;
    top: 0;
  }

  th, td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #eeeeee;
    font-size: 14px;
  }

  th {
    font-weight: 600;
    color: #333;
  }

  tbody tr:hover {
    background-color: #f1f7ff;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
`;

const BtnCancel = styled.button`
  width: 100px;
  height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  
  &:hover {
    background: #888;
  }
`;

export default TobOrderDetailModal;
